import paths from '@app/src/wf-constants/paths'
import { ErrorOutline, NotificationsOutlined } from '@mui/icons-material'
import { Box, Button, CircularProgress, Divider, Stack, Typography, alpha, useTheme } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath, useHistory } from 'react-router-dom'

type ImportEnrichingViewProps = {
  errorCount: number
  onClose: () => void
}

const ImportEnrichingView: React.FC<ImportEnrichingViewProps> = ({ errorCount, onClose }) => {
  const { formatMessage } = useIntl()
  const { palette } = useTheme()
  const history = useHistory()

  const handleGoToNotifications = () => {
    history.push(generatePath(paths.notifications))
    onClose()
  }

  return (
    <Stack height="calc(100vh - 120px)" alignItems="center" justifyContent="center">
      <Stack alignItems="center" justifyContent="center" width={588}>
        <CircularProgress size={64} sx={{ color: palette.communication.dark }} />

        <Typography variant="h6" mt={3}>
          {formatMessage({ id: 'import.enriching.title' })}
        </Typography>

        <Typography color="textSecondary" mt={2} textAlign="center">
          {formatMessage({ id: 'import.enriching.description' })}
        </Typography>

        {errorCount > 0 && (
          <Box
            sx={{
              mt: 4,
              width: '100%',
              bgcolor: alpha(palette.error.main, 0.2),
              p: 2,
            }}
          >
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <ErrorOutline sx={{ color: 'semantic.error' }} />
              <Stack flexGrow={1}>
                <Typography variant="subtitle1">
                  {formatMessage({ id: 'import.summary.failedToImport' }, { count: errorCount })}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {formatMessage({ id: 'import.done.errorDescription' })}
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="text"
                    startIcon={<NotificationsOutlined />}
                    onClick={handleGoToNotifications}
                    sx={{ color: 'text.primary' }}
                  >
                    {formatMessage({ id: 'import.done.goToNotifications' })}
                  </Button>
                </Box>
              </Stack>
            </Stack>
          </Box>
        )}

        <Button variant="contained" sx={{ mt: 4 }} onClick={onClose}>
          {formatMessage({ id: 'general.close' })}
        </Button>
      </Stack>
    </Stack>
  )
}

export default ImportEnrichingView
